var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPricingConnections = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 42 117"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#paint0_linear_3523_13728)",
  d: "M1 27v25.62l6 13.14V117"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#paint1_linear_3523_13728)",
  d: "M41 27v25.62l-6 13.14V117"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#paint2_linear_3523_13728)",
  d: "M14 0v117"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#paint3_linear_3523_13728)",
  d: "M21 0v117"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#paint4_linear_3523_13728)",
  d: "M28 0v117"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_3523_13728",
  x1: 4,
  x2: 4,
  y1: 27,
  y2: 117,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E0E0EB",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E0E0EB"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_3523_13728",
  x1: 38,
  x2: 38,
  y1: 27,
  y2: 117,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E0E0EB",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E0E0EB"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_3523_13728",
  x1: 14.5,
  x2: 14.5,
  y1: 0,
  y2: 117,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E0E0EB",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E0E0EB"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_3523_13728",
  x1: 21.5,
  x2: 21.5,
  y1: 0,
  y2: 117,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E0E0EB",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E0E0EB"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_3523_13728",
  x1: 27.5,
  x2: 27.5,
  y1: 0,
  y2: 117,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E0E0EB",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E0E0EB"
})))));
export { SvgPricingConnections as ReactComponent };
export default "data:image/svg+xml;base64,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";